import Button from 'components/Form/Button';
import UploadFileStage from 'components/Form/UploadFileStage';
import { CoreContext } from 'context/CoreContext';
import { useContext, useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { UploadImage } from 'services/api';
import { UpdateMotor } from 'services/banking';
import { optionsPerfil } from 'utils/options';
import FormCore from '../../Form/Core';
import WrapperTwoCol from '../WrapperTwoCol';
import {
  AddProposalContainer,
  BotaoDocumento,
  CompanyButtonContainer,
} from './styled';

export default function BankingMotor({ dados, reload, onClose, origem }) {
  const { setModal, reloadContent } = useContext(CoreContext);
  const formRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [docBureau, setDocBureau] = useState();

  const close = () => setModal(null);

  const formCrivo = [
    {
      ref: 'bureau_score',
      placeholder: 'Score',
      tress: true,
      type: 'number',
      required: true,
      onBlur: async () => {
        if (!formRef.current) return;
        const informacao = formRef.current.getItem('bureau_score');
        if (informacao >= 751) {
          formRef.current.setItem('A', 'bureau_perfil');
        } else if (informacao >= 501 && informacao <= 750) {
          formRef.current.setItem('B', 'bureau_perfil');
        } else if (informacao >= 400 && informacao <= 500) {
          formRef.current.setItem('C', 'bureau_perfil');
        } else {
          formRef.current.setItem('D', 'bureau_perfil');
        }
      },
    },
    {
      ref: 'bureau_perfil',
      placeholder: 'Perfil',
      tress: true,
      type: 'select',
      options: optionsPerfil,
      required: true,
    },
    {
      ref: 'bureau_renda_presumida',
      placeholder: 'Renda Presumida',
      tress: true,
      type: 'money',
      required: true,
    },
    {
      ref: 'bureau_divida_contratada',
      placeholder: 'Total Dívida Contratada',
      tress: true,
      type: 'money',
      required: true,
    },
    {
      ref: 'bureau_divida_atraso',
      placeholder: 'Dívida em Atraso (30 dias)',
      tress: true,
      type: 'money',
      required: true,
    },
    {
      ref: 'bureau_total_divida_atraso',
      placeholder: 'Total Dívida em Atraso',
      tress: true,
      type: 'money',
      required: true,
    },
    {
      ref: 'serasa_restritivos',
      placeholder: 'Serasa verifica restritivos ',
      tress: true,
      type: 'money',
      required: true,
      default: 0,
    },
    {
      ref: 'bacen_vencidos',
      placeholder: 'Bacen vencidos (R$)',
      tress: true,
      type: 'money',
      required: true,
    },

    {
      ref: 'bacen_prejuizo',
      placeholder: ' Bacen prejuízo (R$)',
      tress: true,
      type: 'money',
      required: true,
    },
    {
      ref: 'bureau_observacoes',
      placeholder: 'Observações',
      full: true,
      type: 'textarea',
      required: false,
    },
  ];

  useEffect(() => {
    if (!dados) {
      return;
    }
    const docBureau = Array.isArray(dados.documento_bureau)
      ? dados.documento_bureau[0]
      : dados?.documento_bureau;
    if (docBureau) {
      setDocBureau(docBureau);
    }
  }, [docBureau, dados]);

  const save = async () => {
    //if (!formRef.current) return toast.error('Erro no formulário');
    const form = await formRef.current.getForm?.();
    if (!form) {
      return;
    }
    setLoading(true);
    const resdocBureau =
      docBureau instanceof File ? await UploadImage(docBureau) : null;
    if (docBureau === null) {
      toast.error('Documento do Bureau é obrigatório.');
      setLoading(false);
      return;
    }
    const payload = {
      bureau_score: form.bureau_score,
      bureau_perfil: form.bureau_perfil,
      serasa_restritivos: form.serasa_restritivos,
      bacen_vencidos: form.bacen_vencidos,
      bacen_prejuizo: form.bacen_prejuizo,
      bureau_total_divida_atraso: form.bureau_total_divida_atraso,
      bureau_divida_atraso: form.bureau_divida_atraso,
      bureau_divida_contratada: form.bureau_divida_contratada,
      bureau_renda_presumida: form.bureau_renda_presumida,
      bureau_observacoes: form.bureau_observacoes,
      data_negocios: new Date(),
      documento_bureau: resdocBureau
        ? resdocBureau[0].id
        : docBureau?.id || null,
    };
    try {
      const result = await UpdateMotor({ data: payload }, dados?.id);
      if (result.status !== 200) {
        throw new Error('Erro ao salvar');
      }
      if (result.curadoria === true && result.aprovado === true) {
        toast.info('Proposta enviado para a Curadoria');
      } else if (result.curadoria === false && result.aprovado === false) {
        toast.error('Proposta recusado');
      } else if (result.curadoria === false && result.aprovado === true) {
        toast.success('Proposta salva com sucesso!');
      } else if (result.curadoria === true && result.aprovado === false) {
        toast.info('Proposta enviado para a Curadoria');
      }
      close();
      reload?.();
      reloadContent?.();
    } catch (err) {
      toast.error(err?.response?.data?.message || 'Erro ao salvar');
    } finally {
      setLoading(false);
    }
  };

  if (!dados) return null;

  const formContent = (
    <AddProposalContainer>
      <FormCore ref={formRef} formItems={formCrivo} />
      <UploadFileStage
        onChange={(file) => setDocBureau(file)}
        proposalType="A_Formalizar"
      >
        <BotaoDocumento>
          {docBureau ? `Selecionado: ${docBureau.name}` : 'Documento do Bureau'}
        </BotaoDocumento>
      </UploadFileStage>
    </AddProposalContainer>
  );

  return (
    <WrapperTwoCol
      onClose={onClose}
      title="Bureau"
      children={formContent}
      titleColumn1="Registro bureau de crédito"
      width="70vw"
      footer={
        <CompanyButtonContainer>
          <Button onClick={close} color="lightgrey" border nospace>
            Cancelar
          </Button>
          <Button color="blue" loading={loading} onClick={save} nospace>
            Salvar Alterações
          </Button>
        </CompanyButtonContainer>
      }
    />
  );
}
